import uuid from 'uuid/v4';

export default () => ({
  'X-REQUEST-ID': uuid(),
  'X-EZCATER-SERVICE-NAME': 'ezcater-ezmanage-ui',
  'X-EZCATER-SOURCE': process.env.BUILD_TARGET,
});
